// Focus time. Expanded in Phase 1 task 1.3 (focus time visual defence).

export const focusTimeCopy = {
  // Weekly KPI
  kpiLabel: 'Focus time this week',
  kpiSuffix: 'protected',
  kpiVsTarget: 'target',

  // Conflict resolution. The popover opens when the user clicks a conflict
  // cell. "Keep focus" dismisses the warning for the session so the user can
  // decline the meeting themselves; "Remove focus" deletes the block so the
  // meeting wins. There is deliberately no third option.
  conflictTitle: 'Meeting overlaps focus',
  conflictBody: 'A meeting has been scheduled over this focus block.',
  conflictKeep: 'Keep focus, decline meeting',
  conflictRemove: 'Remove focus block',
  conflictKeepDone: 'Kept. Decline the meeting in your calendar.',

  // First-run explainer. Shown when the current week has zero focus blocks.
  firstRunHeading: 'Focus time is protected',
  firstRunBody:
    'Focus time is time the EA will defend on your behalf. Block it once, and it holds the week. Start my day will also allocate focus automatically based on your preferences.',
  firstRunAction: 'Add focus block',

  // Block status chips
  sourceAuto: 'Auto',
  sourceManual: 'Manual',
  sourceDetected: 'From calendar',

  // Actions
  addManualBlock: 'Add focus block',
  deleteBlock: 'Remove this block',
} as const;
